import * as React from 'react'
import { parseHostname } from '@workspace/utils/parseHostname'

/*
 * This route does nothing but redirect to the publication domain.
 */
export function StandaloneRedirect() {
  React.useEffect(() => {
    const { publicationDomain } = parseHostname()
    window.location.href = `https://${publicationDomain}`
  }, [])

  return null
}
